<template>
  <a-config-provider :getPopupContainer="getPopupContainer" :locale="zhCN">
    <ThemeProvider is-root v-bind="themeConfig" :apply-style="false">
      <stepin-view
        :system-name="projectName"
        logo-src="@/assets/logo-single.jpg"
        :class="`${contentClass}`"
        :user="user"
        :navMode="navigation"
        :useTabs="useTabs"
        :themeList="themeList"
        v-model:show-setting="showSetting"
        v-model:theme="theme"
        @themeSelect="configTheme"
      >
        <template #headerActions>
          <HeaderActions @showSetting="showSetting = true" />
        </template>
        <template #pageFooter>
          <PageFooter />
        </template>
        <template #themeEditorTab>
          <a-tab-pane tab="其它" key="other">
            <Setting />
          </a-tab-pane>
        </template>
      </stepin-view>
    </ThemeProvider>
  </a-config-provider>
  <!-- <login-modal :unless="['/login', '/register']" /> -->
</template>

<script lang="ts" setup>
import { reactive, ref, watch, h } from 'vue'
import { useRouter } from 'vue-router'
import { useAccountStore, useMenuStore, useSettingStore, storeToRefs, useDictStore } from '@/store'
import avatar from '@/assets/avatar.png'
import { PageFooter, HeaderActions } from '@/components/layout'
import Setting from './components/setting'
import { LoginModal } from '@/pages/login'
import { configTheme, themeList } from '@/theme'
import { ThemeProvider } from 'stepin'
import { computed } from 'vue'
import { message } from 'ant-design-vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'

const projectName = import.meta.env.VITE_BASE_PROJECT_NAME

function onSSEMessage(data: string) {
  if (data === '#ConnectedSuccessfully$') {
    return
  }
  message.info({
    content: data,
    duration: 5,
    key: 'sse'
  })
}

const accountStore = useAccountStore()

const { logout, profile, getAuthInfo, logged } = useAccountStore()

const userInfo = computed(() => {
  return accountStore.userInfo
})

// 获取个人信息
profile().then((response) => {
  const { nickname, icon = null, ifPlayer, id } = response
  user.name = nickname
  user.avatar = icon
  // getAuthInfo();
})
useMenuStore().getMenuList()
useDictStore().dict()

const showSetting = ref(false)
const router = useRouter()
const { navigation, useTabs, theme, contentClass } = storeToRefs(useSettingStore())
const themeConfig = computed(() => themeList.find((item) => item.key === theme.value)?.config ?? {})

watch(userInfo, (val) => {
  user.name = val.nickName
  user.avatar = val.icon
})

const user = reactive({
  name: userInfo.value.nickName,
  avatar: userInfo.value.icon,
  menuList: [
    { title: '个人中心', key: 'personal', icon: 'UserOutlined', onClick: () => router.push('/personal') },
    { title: '设置', key: 'setting', icon: 'SettingOutlined', onClick: () => (showSetting.value = true) },
    { type: 'divider' },
    {
      title: '退出登录',
      key: 'logout',
      icon: 'LogoutOutlined',
      onClick: () => logout().then(() => router.push('/login'))
    }
  ]
})

function getPopupContainer() {
  return document.querySelector('.stepin-layout')
}
</script>

<style lang="less">
.stepin-view {
  ::-webkit-scrollbar {
    width: 6px;
    height: 10px;
    border-radius: 4px;
    background-color: theme('colors.primary.500');
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: theme('colors.primary.500');

    &:hover {
      background-color: theme('colors.primary.500');
    }
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 4px;
    background: theme('backgroundColor.layout');
  }
}

html {
  height: 100vh;
  overflow-y: hidden;
}

body {
  margin: 0;
  height: 100vh;
  overflow-y: hidden;
}
.stepin-img-checkbox {
  @apply transition-transform;
  &:hover {
    @apply scale-105 ~"-translate-y-[2px]";
  }
  img {
    @apply shadow-low rounded-md transition-transform;
  }
}
</style>
